import { render, staticRenderFns } from "./WamSelectRange.vue?vue&type=template&id=56fc0b9c&lang=pug"
import script from "./WamSelectRange.vue?vue&type=script&lang=js"
export * from "./WamSelectRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports